import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["endDate", "discountOption"]

  connect() {
    this.discountOptionTargets.forEach(option => {
      if (option.checked) {
        this.updateEndDate({ target: option })
      }
    })
  }

  updateEndDate(e) {
    const date = e.target.dataset.endDate
    this.endDateTarget.value = date
  }
}
